<template>
  <div class="flex-col self-start group_6 ml-55">
    <el-tabs class="tabs" v-model="selectType">
      <el-tab-pane v-for="(item, index) in typeData" :label="`${item.name}`" :name="item.id" :key="index"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    typeData: Array,
    selectType: String
  },
  watch: {
    selectType (vl) { this.newSelectType = vl },
    newSelectType (vl) { this.$emit('update:selectType', vl) }
  },
  data () {
    return {
      newSelectType: this.selectType
    }
  }
}
</script>

<style lang="less" scoped>
.tabs /deep/ .el-tabs__item{
  min-width: 160px;
  text-align: center;
  padding: 0;
}
.tabs /deep/ .el-tabs__item{
  color: #999 !important;
}
.tabs /deep/ .el-tabs__item:hover,
.tabs /deep/ .el-tabs__item.is-active{
  color: #0067d1 !important;
}
.tabs /deep/ .el-tabs__active-bar{
  background-color: #0067d1 !important;
}
.group_6 {
  width: 1054px;
  height: 50px;
}
</style>
